// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"index-module__inputContainer___1pz2u"};